import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import PrivateRoute from "./components/shared/PrivateRoute";
import Layout from "./components/layout/layout";
import SignUp from "./components/auth/signUp";
import { useEffect } from "react";
// WITH Layout Pages
import Dashboard from "./components/dashboard/Dashboard";
import UpskillPage from "./components/talent/UpskillPage";
import LeadershipPage from "./components/talent/LeadershipPage";
import MobilityPage from "./components/talent/MobilityPage";
import AssignmentsPage from "./components/talent/AssignmentsPage";
import NominationsPage from "./components/talent/NominationsPage";
import RecommendationsPage from "./components/talent/RecommendationsPage";
import HiringPage from "./components/talent/HiringPage";
import HiringProfileDetailPage from "./components/talent/HiringProfileDetailPage";
import { getBillingSubscriptionAccess } from "./components/shared/access";
import EmployeesPage from "./components/employees/EmployeesPage";
import EmployeeCreatePage from "./components/employees/EmployeeCreatePage";
import EmployeeEditPage from "./components/employees/EmployeeEditPage";
import CandidateProfilePage from "./components/employees/CandidateProfilePage";
import ExternalCandidateProfilePage from "./components/employees/ExternalCandidateProfilePage";

import JobRolesPage from "./components/jobs/job-roles-page";

import TeamsPage from "./components/teams/TeamsPage";
import TeamCreatePage from "./components/teams/TeamCreatePage";
import TeamEditPage from "./components/teams/TeamEditPage";
import TeamDetailPage from "./components/teams/TeamDetailPage";

import SettingsPage from "./components/settings/SettingsPage";
import ProfilePage from "./components/settings/ProfilePage";
import OrganizationInfoPage from "./components/settings/OrganizationInfoPage";
import UserSettingsPage from "./components/settings/UserSettingsPage";

import OrganizationsPage from "./components/organizations/OrganizationsPage";
import OrganizationCreatePage from "./components/organizations/OrganizationCreatePage";
import OrganizationEditPage from "./components/organizations/OrganizationEditPage";
import OrganizationDetailPage from "./components/organizations/OrganizationDetailPage";

import ReportsPage from "./components/reports/ReportsPage";
import PreGeneratedReportsPage from "./components/reports/PreGeneratedReportsPage";
import AnalysisComparisonPage from "./components/reports/AnalysisComparisonPage";
import BusinessInsightsPage from "./components/reports/BusinessInsightsPage";
import DetailedComparisonPage from "./components/reports/DetailedComparisonPage";
import DetailedPreGeneratedReportPage from "./components/reports/DetailedPreGeneratedReportPage";
import DetailedBusinessInsightPage from "./components/reports/DetailedBusinessInsightPage";

import TermsPage from "./components/legal/TermsPage";
import PrivacyPage from "./components/legal/PrivacyPage";
import SignIn from "./components/auth/signIn";
import Landing from "./components/portalSelector/portalSelector";
import ForgotPasscode from "./components/auth/forgotPasscode";
import TalentRedirection from "./components/shared/talentRedirection";
import HomeBootstrapGate from "./components/shared/HomeBootstrapGate";
import ContactForm from "./components/layout/ContactForm";
import NotFound from "./components/layout/NotFound";
import Pricing from "./components/pricing/Pricing";
import { getLogoutUrl } from "../src/components/shared/utils/logoutRedirect"; // adjust path
import ManageBillingsPage from "./components/layout/ManageBillingsModal";

import TIA from "./components/TIA/tia";

const HardLogoutRedirect = () => {
  useEffect(() => {
    window.location.replace(getLogoutUrl());
  }, []);
  return null;
};

/**
 * Optional: if user is logged-in and hits an unknown route, send them to /home.
 * If they are logged-out, hard redirect like Header logout.
 */
const AuthAwareFallback = () => {
  const isAuthed = Boolean(
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("accessToken") ||
    sessionStorage.getItem("authToken"),
  );

  if (isAuthed) return <Navigate to="/home" replace />;
  return <HardLogoutRedirect />;
};
const HardEnvRedirect = () => {
  useEffect(() => {
    window.location.replace(getLogoutUrl()); // env-based absolute redirect
  }, []);
  return null;
};
const BillingSubscriptionRoute = ({ children }) => {
  const location = useLocation();
  const billingAccess = getBillingSubscriptionAccess();

  if (!billingAccess.canViewPage) {
    return <Navigate to="/home" replace state={{ from: location }} />;
  }

  return children;
};
const AppRoutes = () => (
  <Routes>
    {/* ✅ Empty route -> env-based redirect (NOT /signin SPA navigation) */}
    <Route path="/" element={<HardEnvRedirect />} />
    {/* Public Route: Login */}
    {/* <Route path="/" element={<Navigate to="/signin" replace />} /> */}
    {/* <Route path="/signin" element={<SignIn />} /> */}
    {/* <Route path="/signup" element={<SignUp />} /> */}
    <Route path="/signin" element={<TalentRedirection />} />
    <Route path="/signup" element={<TalentRedirection />} />

    <Route path="/forgot-password" element={<ForgotPasscode />} />
    {/* {SIGNIN PAGE} */}

    <Route path="/auth/google/callback" element={<SignUp />} />
    <Route element={<HomeBootstrapGate />}>
      <Route element={<Layout />}>
        <Route path="home" element={<Dashboard />} />
      </Route>
    </Route>

    {/* Guarded Routes */}
    <Route element={<PrivateRoute />}>
      <Route element={<Layout />}>
        {/* <Route path="home" element={<Dashboard />} /> */}
        {/* <Route path="landing" element={<Landing />} /> */}
        {/* Talent */}
        <Route path="talent-development/upskill" element={<UpskillPage />} />
        <Route
          path="talent-development/leadership"
          element={<LeadershipPage />}
        />
        <Route path="talent-development/mobility" element={<MobilityPage />} />
        <Route
          path="talent-development/assignments"
          element={<AssignmentsPage />}
        />
        <Route
          path="talent-development/nominations"
          element={<NominationsPage />}
        />
        <Route
          path="talent-development/recommendations"
          element={<RecommendationsPage />}
        />
        <Route path="talent-development/hiring" element={<HiringPage />} />
        <Route
          path="talent-development/hiring/profiles/:profileId"
          element={<HiringProfileDetailPage />}
        />
        <Route
          path="talent-development/hiring/external-profiles/:id"
          element={<ExternalCandidateProfilePage />}
        />

        {/* Employees */}
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="employees/create" element={<EmployeeCreatePage />} />
        <Route path="employees/edit/:id" element={<EmployeeEditPage />} />
        <Route path="employees/:id" element={<CandidateProfilePage />} />
        <Route
          path="external-candidates/:id"
          element={<ExternalCandidateProfilePage />}
        />

        {/* Job Roles */}
        <Route path="job-roles" element={<JobRolesPage />} />

        {/* Teams */}
        <Route path="teams" element={<TeamsPage />} />
        <Route path="teams/create" element={<TeamCreatePage />} />
        <Route path="teams/edit/:id" element={<TeamEditPage />} />
        <Route path="teams/:id" element={<TeamDetailPage />} />

        {/* Settings */}
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/profile" element={<ProfilePage />} />
        <Route path="settings/users" element={<UserSettingsPage />} />
        <Route
          path="settings/onboard-organization"
          element={<OrganizationsPage />}
        />
        <Route
          path="settings/organization-info"
          element={<OrganizationInfoPage />}
        />

        {/* Organizations */}
        {/* NAME OF THE ORGANIZATION IS CHANGED TO BRAND */}
        <Route path="brand" element={<OrganizationsPage />} />
        <Route path="brand/create" element={<OrganizationCreatePage />} />
        <Route path="brand/edit/:id" element={<OrganizationEditPage />} />
        <Route path="brand/:id" element={<OrganizationDetailPage />} />

        {/* Reports */}
        <Route path="reports" element={<ReportsPage />} />
        <Route
          path="reports/pre-generated"
          element={<PreGeneratedReportsPage />}
        />
        <Route
          path="reports/analysis-comparison"
          element={<AnalysisComparisonPage />}
        />
        <Route
          path="reports/business-insights"
          element={<BusinessInsightsPage />}
        />
        <Route
          path="reports/detailed-comparison"
          element={<DetailedComparisonPage />}
        />
        <Route
          path="reports/detailed-pre-generated/:id"
          element={<DetailedPreGeneratedReportPage />}
        />
        <Route
          path="reports/detailed-business-insights/:id"
          element={<DetailedBusinessInsightPage />}
        />

        {/* Legal */}
        <Route path="legal/terms" element={<TermsPage />} />
        <Route path="legal/privacy" element={<PrivacyPage />} />

        {/* Contact */}
        <Route path="contact" element={<ContactForm />} />

        {/* Pricing */}
        <Route path="pricing" element={<Pricing />} />
        {/* <Route path="manage-billings" element={<ManageBillingsPage />} /> */}
        <Route
          path="manage-billings"
          element={
            <BillingSubscriptionRoute>
              <ManageBillingsPage />
            </BillingSubscriptionRoute>
          }
        />

        {/* TIA */}
        <Route path="tia" element={<TIA />} />

        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>
  </Routes>
);

export default AppRoutes;
